import { SLUG_RE } from "@/mk2/helpers/urls";

const TESTING_SLUG = `:slug(${SLUG_RE})`;

export const testingsHomeUrl = `/testing/`;
export const testingDetailUrl = `/testing/${TESTING_SLUG}`;
export const testingFinishedPostEditUrl = `/testing/${TESTING_SLUG}/edit`;
